/**
 * @generated SignedSource<<90c74237e8a3bed7473a0fdde5d66736>>
 * @relayHash a6cb0b8293fba9cb6132788c262bb83a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7da55071366de2036ae63cccb45d6115bcc779f09404b843e4d32ed50f5e62c7

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneysPageQuery } from './JourneysPageQuery.graphql';

const node: PreloadableConcreteRequest<JourneysPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "7da55071366de2036ae63cccb45d6115bcc779f09404b843e4d32ed50f5e62c7",
    "metadata": {},
    "name": "JourneysPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
